import { useInternationalization } from "@progress/kendo-react-intl";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { IDetailItem } from "../../utilities/DetailItem";
import { QuoteDetailsSubHeader } from "../quoteDetails/QuoteDetailsSubHeader";

export const AccumulatorStepperHeader = ({
  quoteId,
  quoteName,
  product,
  contract,
  lookups,
  values,
}: any) => {
  const { commodity, instrument, company } = product;
  const { doubleUpTypes, knockOutTypes, settlementTypes, types } = lookups;
  const formatter = useInternationalization();

  const doubleUp = doubleUpTypes.find((d: any) => d.value === values?.doubleUpTypeId);
  const knockOut = knockOutTypes.find((d: any) => d.value === values?.knockOutTypeId);
  const settlementType = settlementTypes.find((d: any) => d.value === values?.settlementTypeId);
  const instrumentType = types.find((d: any) => d.value === values?.instrumentTypeId);

  const Separator = () => {
    return <span className={"k-form-separator"} style={{ margin: "10px 0" }} />;
  };

  const subHeaderDetails1: IDetailItem[] = [
    { label: "ID", content: quoteId },
    ...(company?.name ? [{ label: "Client", content: company.name }] : []),
    { label: "Contract", content: contract },
    {
      label: "Volume",
      content: `${formatter.formatNumber(values?.volume, "n0")} ${commodity.units}`,
    },
  ];

  const subHeaderDetails2: IDetailItem[] = [
    { label: "Type", content: instrumentType?.text || "" },
    { label: "Knock-Out", content: knockOut?.text || "" },
    { label: "Double Up", content: doubleUp?.text || "" },
    { label: "Fixing Frequency", content: settlementType?.text || "" },
  ];

  return (
    <div>
      <Separator />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "10px 0",
        }}
      >
        <div>
          <Tooltip anchorElement="target" position="top">
            <img
              alt={commodity.name}
              src={commodity.icon()}
              title={`${commodity.name} (${commodity.abbreviation})`}
              style={{ width: 24, height: 24, paddingRight: ".25rem" }}
            />
            <img
              alt={instrument.productType}
              src={instrument.icon()}
              title={instrument.productType}
              style={{ width: 24, height: 24, paddingRight: ".25rem" }}
            />
            <span style={{ fontWeight: "bolder" }}>{quoteName}</span>
          </Tooltip>
        </div>
      </div>

      <Separator />
      <QuoteDetailsSubHeader details={subHeaderDetails1} />

      <Separator />
      <QuoteDetailsSubHeader details={subHeaderDetails2} />
    </div>
  );
};
